import { BillStatus } from "@prisma/client";

/**
 * Client-side bill predicates for demote/UI blockers.
 * Parent status rules: `src/shared/accounting/bill-document-eligibility.ts`.
 * WOV2 engine guard: `work-order-v2/engine/transitions/demote.ts`.
 *
 * Bill status semantics: `src/server/domain/accounts-payable/BILL_LIFECYCLE.md`
 */

/** Unified copy when non-void AP bills block demotion to a non-billable parent status. */
export const reverseSubmitBillBlockMessage = "Must void bill before demoting this document";

/** Bill row is linked for demote/UI blocking when status is anything other than VOID. */
export function isNonVoidBillStatus(status: BillStatus): boolean {
  return status !== BillStatus.VOID;
}

export function hasNonVoidBillRows<T extends { Bill?: { status: BillStatus } | null }>(rows: T[] | undefined): boolean {
  return (rows ?? []).some(row => row.Bill != null && isNonVoidBillStatus(row.Bill.status));
}
